module.exports = __webpack_public_path__ + "static/media/fi-br-angle-double-right.46a28351.svg";